<template>
  <div class="tab-block">

    <div class="tab-list" v-if="tabData.list?.length">
      <div class="tab-item hover-text" :class="{ 'tab-active': seccode || code ? item.categoryCode == seccode
       || item.categoryCode == code : index == 0 }" v-for="(item, index) in tabData.list" :key="index" @click="changeTab(item, item.categoryCode)">
        <div class="tab-item-title">
          <div class="title">{{ item.categoryName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tabData", "code", "seccode", "subcode"],
  data() {
    return {
      isActive: false,
      currentCode: this.code,
    };
  },
  watch: {

  },
  created() { },
  methods: {
    //切换栏目
    changeTab(item, tab) {
      this.$emit("changeSecTab", item, tab);
    },

  },
};
</script>

<style lang="scss" scoped>
.tab-block {
  display: flex;
  flex-direction: column;
  min-height: 92px;
  width: 100%;

  .tab-list {
    display: flex;
    flex-direction: column;
    font-size: 18px;
    padding: 0 18px 0 16px;

    .tab-item {
      position: relative;
      flex: 1;
      display: flex;
      background-color: #f4f4fc;

      justify-content: center;
      margin-top: 1px;
      cursor: pointer;

      .tab-item-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 100px;
      }

      .title {
        flex: 1;
        display: -webkit-box;
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
    }

    .title:hover {
      border-right-color: #4ea4f9 !important;
    }

    .tab-active {
      background-color: #4ea4f9;
      .tab-item-title {
        color: #ffffff;
      }
    }
  }
}
</style>
